import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { takeUntil } from 'rxjs';

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UploadStudyModalComponent } from 'src/app/clinic-studies/upload-study-modal/upload-study-modal.component';
import { LoginModel } from 'src/app/models/legacy';
import { SubmissionsFacade } from 'src/app/shared-new/store/submissions/submissions.facade';
import Swal from 'sweetalert2';
import { HttpErrorHandlerService } from '../../services/http-error-handler.service';
import { AuthService } from '../../services/auth.service';
import { BaseUnsubscribeComponent } from '../../shared-new/components/base-unsubscribe/base-unsubscribe.component';

declare var $: any;
@Component({
  selector: 'left-navigation',
  templateUrl: './left-navigation.component.html',
  styleUrls: ['./left-navigation.component.scss'],
})
export class LeftNavigationComponent
  extends BaseUnsubscribeComponent
  implements OnInit {
  @Input() isSideBarOpen: boolean = false;

  public isLoginStatus: boolean;
  public user: LoginModel;

  public isUserHasUploadAccess: boolean = false;
  public isSalesEditor: boolean = false;
  public isLocalStorageEnabled: boolean = false;
  public isSaleFeatureEnabled: boolean = false;
  isSalesCompany = false;
  isVet = false;
  isSuperUser = false;
  isUSA = false;
  draftSubmissionCount$ = this.submissionsFacade.draftSubmissionCount$;

  public constructor(
    public readonly authService: AuthService,
    private readonly router: Router,
    private readonly activeRoute: ActivatedRoute,
    private readonly httpErrorHandlerService: HttpErrorHandlerService,
    private modalService: NgbModal,
    private submissionsFacade: SubmissionsFacade
  ) {
    super();
  }

  public ngOnInit(): void {
    this.isSalesCompany = this.authService.IsSalesCompany();
    this.isVet = this.authService.IsVet();
    this.isSuperUser = this.authService.IsSuperUser();

   
    this.authService.getUserData().subscribe((data) => {
      const user = JSON.parse(data);

      this.isUSA = user?.region?.toLowerCase() === 'usa';
    });
  

    if (this.isVet) {
      this.submissionsFacade.loadDraftSubmissionCount();
    }
    this.userAuthenticate();
    this.isUserHasUploadAccess =
      this.authService.GlobalMemberAccessData.isSubmitAccess;
    this.isSalesEditor = this.authService.GlobalMemberAccessData.isSalesEditor;
    this.isLocalStorageEnabled = this.authService.GlobalMemberAccessData.isLocalStorageEnabled;
    this.isSaleFeatureEnabled =
      this.authService.GlobalMemberAccessData.isSaleFeatureEnabled;
  }

 

  public naviagetToDownloadLocalStorage(): void {
    this.router.navigate(['/clinic-studies/download-localstorage'])
  }

  public goHome(): void {
    if (!this.authService.GlobalMemberAccessData.isSaleFeatureEnabled) {
      window.location.href = '/clinic-studies';
    } else {
      window.location.href = '/sales';
    }
  }
  public redirectToCenter() {
    if (this.isVet) {
      window.open('https://help.thoroughrepository.com/-veterinarian-user', '_blank');
    } else {
      window.open('https://help.thoroughrepository.com/', '_blank');
    }
  }

  public redirectToContactUs() {
    window.open('https://www.thoroughrepository.com/contact-us', '_blank');
  }

  public userAuthenticate(): void {
    this.isLoginStatus = this.authService.isAuthenticated();
    this.authService.getUserData().subscribe((data) => {
      if (data) {
        this.user = JSON.parse(data);
      }
    });
  }

  public logout(): boolean {
    this.router.navigate(['']);
    this.authService
      .logout()
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((response) => {
        location.href = '/';
      });
    return true;
  }

  openUploadModal(): void {
    this.modalService
      .open(UploadStudyModalComponent, {
        size: 'lg',
        centered: true,
        keyboard: false,
        backdrop: 'static',
      })
      .closed.subscribe((res) => {
        if (res?.studyId) {
          if (this.isSaleFeatureEnabled) {
            this.router.navigate(['clinic-studies', 'view', res.studyId], {
              relativeTo: this.activeRoute,
            });
          } else {
            document.location = '/clinic-studies';
          }
        }
      });
  }

  refreshTwRepoData(): void {
    let isLoading = false;
    Swal.fire({
      title: 'Refresh Tw Repo Data',
      text: 'Do you want to refresh tw repo data?',
      showCancelButton: !isLoading,
      cancelButtonText: 'Cancel',
      cancelButtonColor: '#6c757d',
      confirmButtonText: 'Refresh',
      confirmButtonColor: '#1b6da6',
      showLoaderOnConfirm: false,
      allowOutsideClick: () => !isLoading,
      preConfirm: async () => {
        try {
          // Convert the Observable to a Promise using toPromise()
          const response = await this.authService
            .refreshTwRepoData()
            .toPromise();

          // Handle the response
          if (!response) {
            throw new Error('Response is falsy'); // Throw an error to trigger Swal.showValidationMessage
          }

          return response;
        } catch (error: any) {
          this.httpErrorHandlerService.ShowErrorMessage(error);
          // Ensure a value is returned even in case of an error
          return false;
        }
      },
      willOpen: () => {
        isLoading = true;
        //Swal.hideLoading();
      },
      willClose: () => {
        isLoading = false;
        //Swal.showLoading();
      },
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire('Success', 'Data refreshed successfully', 'success');
      }
    });
  }
}
